import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { ShowReference } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type PaymentReceiptTypeViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  name_esValue?: { displayId: string; id: string } | null;
  name_es: string;
  name_enValue?: { displayId: string; id: string } | null;
  name_en: string;
  name_ptValue?: { displayId: string; id: string } | null;
  name_pt: string;
  priceValue?: { displayId: string; id: string } | null;
  price: number;
  currencyValue: { displayId: string; id: string } | null;
};

export const PaymentReceiptTypeViewForm: React.FC<PaymentReceiptTypeViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      name_es = "",
      name_en = "",
      name_pt = "",
      price = 0,
      currencyValue,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupPaymentReceiptTypeLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={name_es}
                  label={langStore.PaymentReceiptTypeNameLabel + " (es)"}
                />
                ,
                <ShowMultiLine
                  value={name_en}
                  label={langStore.PaymentReceiptTypeNameLabel + " (en)"}
                />
                ,
                <ShowMultiLine
                  value={name_pt}
                  label={langStore.PaymentReceiptTypeNameLabel + " (pt)"}
                />
                <ShowNumber
                  value={price}
                  label={langStore.PaymentReceiptTypePriceLabel}
                  decimalScale={2}
                />
                <ShowReference
                  label={langStore.PaymentReceiptTypeCurrencyLabel}
                  selectedValue={langStore.displayIdByLang(
                    currencyValue?.displayId
                  )}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
